import React, { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import useReactRouter from "use-react-router";
import {
  gcp_docs,
  DisPlayFiles,
  endOfMonth,
  formatDateDash,
  getStaffLogin,
  setParams,
  startOfMonth,
} from "../../helper";
import { FaFile, FaImage } from "react-icons/fa";
import { QUERY_DOCUMENTS } from "../documents/apollo";
import Pagination from "../../helper/components/pagination/Pagination";
import ListDocumentType from "../../helper/components/pagination/DocumentType";
import LimitData from "../../controllers/LimitData";

export default function AllFilesList() {
  const _user = getStaffLogin().data;
  const { history, location } = useReactRouter();
  const queryParams = new URLSearchParams(location?.search);
  const [searchValue, setSearchValue] = useState("");
  const [newLoadData, setNewLoadData] = useState(false);
  const [documentType, setDocumentType] = useState([]);
  const [listDocument, setListDocument] = useState([]);
  const [listDocumentPrivate, setListDocumentPrivate] = useState([]);
  const [startDate, setStartDate] = useState(startOfMonth());
  const [endDate, setEndDate] = useState(endOfMonth());
  const [numberPage, setNumberPage] = useState(1);
  const [numberRow, setNumberRow] = useState(20);

  const [queryDocument, { data: resultData }] = useLazyQuery(QUERY_DOCUMENTS, {
    fetchPolicy: "cache-and-network",
  });
  const [queryDocumentPrivate, { data: resultDataPrivate }] = useLazyQuery(
    QUERY_DOCUMENTS,
    { fetchPolicy: "cache-and-network" }
  );

  useEffect(() => {
    queryDocument({
      variables: {
        where: {
          departmentID: parseInt(_user?.department?._id),
          createdAt_gte: startDate || undefined,
          createdAt_lte: endDate || undefined,
          isDeleted: 0,
          isPublic: 1,
          isPrivate: 0,
          typeDocument: documentType?._id || undefined,
        },
        skip: numberRow * (numberPage - 1),
        limit: parseInt(numberRow),
        orderBy: "createdAt_DESC",
      },
    });

    queryDocumentPrivate({
      variables: {
        where: {
          createdBy: parseInt(_user?._id),
          createdAt_gte: startDate || undefined,
          createdAt_lte: endDate || undefined,
          isDeleted: 0,
          isPublic: 1,
          isPrivate: 1,
          typeDocument: documentType?._id || undefined,
        },
        skip: numberRow * (numberPage - 1),
        limit: parseInt(numberRow),
        orderBy: "createdAt_DESC",
      },
    });
  }, [newLoadData, startDate, endDate, numberPage, numberRow, documentType]);

  useEffect(() => {
    const results = resultData?.documents?.data;
    if (searchValue) {
      const filter = results?.filter((obj) => {
        if (
          obj?.documentID?.includes(searchValue) ||
          obj?.title?.includes(searchValue)
        ) {
          return obj;
        }
      });
      setListDocument(filter);
    } else {
      setListDocument(results);
    }
  }, [resultData, searchValue]);

  useEffect(() => {
    const results = resultDataPrivate?.documents?.data;
    if (searchValue) {
      const filter = results?.filter((obj) => {
        if (
          obj?.documentID?.includes(searchValue) ||
          obj?.title?.includes(searchValue)
        ) {
          return obj;
        }
      });
      setListDocumentPrivate(filter);
    } else {
      setListDocumentPrivate(results);
    }
  }, [resultDataPrivate, searchValue]);

    // page
  useEffect(() => {
    let _startDate = queryParams.get("startDate");
    let _endDate = queryParams.get("endDate");
    let _page = queryParams.get("page");
    setNumberPage(_page ? parseInt(_page) : 1);
    if (_startDate) {
      setStartDate(_startDate);
    } else {
      setStartDate(startOfMonth());
    }
    if (_endDate) {
      setEndDate(_endDate);
    } else {
      setEndDate(endOfMonth());
    }
  }, [queryParams]);

  const countData = resultData?.documents?.total;
  const countDataPrivate = resultDataPrivate?.documents?.total;
  const _countData = countData + countDataPrivate;

  const countPage = [];
  for (var i = 1; i <= Math.ceil(_countData / numberRow); i++) {
    countPage.push(i);
  }

  const DOC_EXTS = [
    "pdf",
    "presentation",
    "pptx",
    "ppt",
    "pptm",
    "document",
    "docx",
    "doc",
    "docm",
    "dotx",
    "xlsx",
    "xls",
    "xlsm",
    "sheet",
  ];
  const IMG_EXTS = ["jpeg", "jpg", "png", "gif", "svg"];

  const getKey = (prefix, item, idx) =>
    item?._id ?? item?.documentID ?? item?.files ?? `${prefix}-${idx}`;

  return (
    <>
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <h3>ຂໍ້ມູນເອກະສານທັງໝົດ</h3>
        <hr />
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="mb-md-0 mb-2 d-flex align-items-center gap-2">
                  <div className="dropdown me-3">
                    <input
                      type="text"
                      className="form-control w-100"
                      placeholder="ຄົ້ນຫາດ້ວຍຊື່ເອກະສານ"
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center flex-wrap">
                  <div className="dropdown me-3">
                    <ListDocumentType
                      getData={(data) => {
                        setDocumentType(data);
                      }}
                      defaultValue={documentType?.title}
                    />
                  </div>
                  <div className="dropdown me-3">
                    <div className="input-group">
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) =>
                          history.push({
                            search: setParams(`startDate`, e.target.value),
                          })
                        }
                      />
                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) =>
                          history.push({
                            search: setParams(`endDate`, e.target.value),
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="dropdown me-3">
                    <LimitData
                      onChange={(val) => {
                        setNumberRow(val);
                      }}
                    />
                  </div>
                  <div className="dropdown me-3 pt-2">
                    <Pagination
                      className="mt-2"
                      pageTotal={countPage}
                      currentPage={numberPage}
                      onPageChange={(page) => {
                        history.push({
                          search: setParams(`page`, page),
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h4 className="py-3 mb-0">
          <FaFile className="me-2" /> ໄຟລ໌ເອກະສານຕ່າງໆ {""}
          {(countData + countDataPrivate)|| 0} ໄຟລ໌
        </h4>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4">
          {listDocument?.map((item, idx) =>
            DOC_EXTS.includes(item?.files.split(".").pop()) ? (
              <div className="col" key={getKey("doc", item, idx)}>
                <div className="card iq-file-manager">
                  <div className="card-body card-thumbnail">
                    <div className="p-3 d-flex justify-content-center align-items-center iq-document rounded bg-body">
                      <DisPlayFiles
                        file={item?.files}
                        className="file"
                        width={100}
                        height={100}
                        item={item}
                      />
                    </div>
                    <div className="mt-2">
                      <div className="small">
                        <i className="icon-clock me-1" /> ວັນທີ່ສ້າງ:{" "}
                        {formatDateDash(item?.createdAt)}
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-unfold_more" />
                        <div className="mb-0 text-primary fw-bolder me-3">
                          {item?.documentID || "No Document ID"}
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-text_fields" />
                        <div className=" mb-0 text-dark me-3">
                          {item?.title?.substring(30)
                            ? item?.title?.substring(0, 30) + "..."
                            : item?.title}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <a
                          className="btn btn-secondary btn-sm w-100 rounded-pill"
                          href={gcp_docs + item?.files}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-solid fa-circle-down me-1" />
                          ດາວໂຫຼດ
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          )}

          {listDocumentPrivate?.map((item, idx) =>
            DOC_EXTS.includes(item?.files.split(".").pop()) ? (
              <div className="col" key={getKey("doc-private", item, idx)}>
                <div className="card iq-file-manager">
                  <div className="card-body card-thumbnail">
                    <div className="p-3 d-flex justify-content-center align-items-center iq-document rounded bg-body">
                      <DisPlayFiles
                        file={item?.files}
                        className="file"
                        width={100}
                        height={100}
                        item={item}
                      />
                    </div>
                    <div className="mt-2">
                      <div className="small">
                        <i className="icon-clock me-1" /> ວັນທີ່ສ້າງ:{" "}
                        {formatDateDash(item?.createdAt)}
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-unfold_more" />
                        <div className="mb-0 text-primary fw-bolder me-3">
                          {item?.documentID || "No Document ID"}
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-text_fields" />
                        <div className=" mb-0 text-dark me-3">
                          {item?.title?.substring(30)
                            ? item?.title?.substring(0, 30) + "..."
                            : item?.title}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <a
                          className="btn btn-secondary btn-sm w-100 rounded-pill"
                          href={gcp_docs + item?.files}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-solid fa-circle-down me-1" />
                          ດາວໂຫຼດ
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          )}
        </div>

        <h4 className="py-3 mb-0">
          <FaImage className="me-2" /> ຮູບພາບ
        </h4>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4">
          {listDocument?.map((item, idx) =>
            IMG_EXTS.includes(item?.files.split(".").pop()) ? (
              <div className="col" key={getKey("img", item, idx)}>
                <div className="card iq-file-manager">
                  <div className="card-body card-thumbnail">
                    <div className="p-3 d-flex justify-content-center align-items-center iq-document rounded bg-body">
                      <DisPlayFiles
                        file={item?.files}
                        className="file"
                        width={100}
                        height={100}
                        item={item}
                      />
                    </div>
                    <div className="mt-2">
                      <div className="small">
                        <i className="icon-clock me-1" /> ວັນທີ່ສ້າງ:{" "}
                        {formatDateDash(item?.createdAt)}
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-unfold_more" />
                        <div className="mb-0 text-primary fw-bolder me-3">
                          {item?.documentID || "No Document ID"}
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-text_fields" />
                        <div className=" mb-0 text-dark me-3">
                          {item?.title?.substring(30)
                            ? item?.title?.substring(0, 30) + "..."
                            : item?.title}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <a
                          className="btn btn-secondary btn-sm w-100 rounded-pill"
                          href={gcp_docs + item?.files}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-solid fa-circle-down me-1" />
                          ດາວໂຫຼດ
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          )}

          {listDocumentPrivate?.map((item, idx) =>
            IMG_EXTS.includes(item?.files.split(".").pop()) ? (
              <div className="col" key={getKey("img-private", item, idx)}>
                <div className="card iq-file-manager">
                  <div className="card-body card-thumbnail">
                    <div className="p-3 d-flex justify-content-center align-items-center iq-document rounded bg-body">
                      <DisPlayFiles
                        file={item?.files}
                        className="file"
                        width={100}
                        height={100}
                        item={item}
                      />
                    </div>
                    <div className="mt-2">
                      <div className="small mb-2">
                        ວັນທີ່ສ້າງ: {formatDateDash(item?.createdAt)}
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-unfold_more" />
                        <div className="mb-0 text-primary fw-bolder me-3">
                          {item?.documentID || "No Document ID"}
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-text_fields" />
                        <div className=" mb-0 text-dark me-3">
                          {item?.title?.substring(30)
                            ? item?.title?.substring(0, 30) + "..."
                            : item?.title}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <a
                          className="btn btn-secondary btn-sm w-100 rounded-pill"
                          href={gcp_docs + item?.files}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa-solid fa-circle-down me-1" />
                          ດາວໂຫຼດ
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          )}
        </div>
      </div>
    </>
  );
}
